export const SEGMENT_COLOR_PRESETS = [
  '#1F47AB',
  '#0E8E8E',
  '#0F9D6B',
  '#D97706',
  '#C0392B',
  '#7C3AED',
  '#DB2777',
  '#475569',
];
